import { render, staticRenderFns } from "./NewModal.vue?vue&type=template&id=2141d92e&scoped=true&lang=pug&"
import script from "./NewModal.vue?vue&type=script&lang=js&"
export * from "./NewModal.vue?vue&type=script&lang=js&"
import style0 from "./NewModal.vue?vue&type=style&index=0&id=2141d92e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2141d92e",
  null
  
)

export default component.exports